// reach_ui/src/actions/customForm/addOrEdit/index.js
import ActionType from 'actions/ActionType'
import { read } from 'actions/data'
import { getAllGroups } from 'actions/contacts/groups'

export const toggleCustomLandingPage = payload => dispatch =>
  dispatch({ type: ActionType.CustomForm.TOGGLE_CUSTOM_LANDING_PAGE, payload })

export const moveSection =
  (dragIndex, hoverIndex, pageBreakIndices) => dispatch =>
    dispatch({
      type: ActionType.CustomForm.MOVE_SECTION,
      dragIndex,
      hoverIndex,
      pageBreakIndices,
    })

export const moveToPage = payload => (dispatch, getState) => {
  const { index, page, pagebreak, direction } = payload

  const { pageSelected, form, sectionsByID } = getState().customForm.addOrEdit
  const sections = form.sections.map((section, idx) => ({
    ...sectionsByID[section],
    idx,
  }))

  const pageBreakIndices = sections
    .filter(el => el?.type === 'pagebreak')
    .map(pageBreakEl => pageBreakEl.idx)

  const pages = [
    ...pageBreakIndices.map((pageBreakIdx, idx) => idx),
    pageBreakIndices.length,
  ]

  let visibleSections = sections

  if (pageBreakIndices.length) {
    if (pageSelected === 0) {
      visibleSections = sections.slice(0, pageBreakIndices[0])
    } else if (pageSelected === pages.length - 1) {
      visibleSections = sections.slice(pageBreakIndices[pageSelected - 1])
    } /* (pageSelected !== pageBreakIndices.length - 1) */ else {
      visibleSections = sections.slice(
        pageBreakIndices[pageSelected - 1],
        pageBreakIndices[pageSelected],
      )
    }
  }

  const actualIndex =
    pageSelected === 0
      ? visibleSections[index].idx
      : visibleSections[index].idx + 1

  // if page === 0 then it needs to be at 0, if page === 7 it needs to be after the 6th one

  const newIndex =
    page === 0
      ? 0
      : direction === 'forward'
      ? pageBreakIndices[page - 1]
      : pageBreakIndices[page - 1] + 1

  return dispatch({
    type: ActionType.CustomForm.MOVE_TO_PAGE,
    payload: { index: actualIndex, page, pagebreak, newIndex },
  })
}

export const dragPill = index => dispatch =>
  dispatch({
    type: ActionType.CustomForm.DRAG_PILL,
    index,
  })

export const addSection =
  (payload = {}) =>
  (dispatch, getState) => {
    const { pageSelected, form, sectionsByID } = getState().customForm.addOrEdit
    const sections = form.sections.map(section => sectionsByID[section])

    const pageBreakIndices = sections
      .map((section, idx) => ({ ...section, idx }))
      .filter(el => el?.type === 'pagebreak')
      .map(pagebreak => pagebreak.idx)

    const pages = [
      ...pageBreakIndices.map((pageBreakIdx, idx) => idx),
      pageBreakIndices.length,
    ]

    let visibleSections = sections

    if (pageBreakIndices.length) {
      if (pageSelected === 0) {
        visibleSections = sections.slice(0, pageBreakIndices[0])
      } else if (pageSelected === pages.length - 1) {
        visibleSections = sections.slice(pageBreakIndices[pageSelected - 1])
      } /* (pageSelected !== pageBreakIndices.length - 1) */ else {
        visibleSections = sections.slice(
          pageBreakIndices[pageSelected - 1],
          pageBreakIndices[pageSelected],
        )
      }
    }

    const sectionSelected = payload.index || visibleSections.length

    const index = pageBreakIndices[pageSelected]

    return dispatch({
      type: ActionType.CustomForm.ADD_SECTION,
      payload: {
        index,
        sectionSelected,
        editSection: sectionSelected,
        ...payload,
      },
    })
  }

export const changeSection = (payload, index, id) => (dispatch, getState) =>
  new Promise(resolve => {
    const { pageSelected, form } = getState().customForm.addOrEdit
    const sections = form.sections.map((section, idx) => ({ ...section, idx }))

    const pageBreakIndices = sections
      .map((section, idx) => ({ ...section, idx }))
      .filter(el => el?.type === 'pagebreak')
      .map(pagebreak => pagebreak.idx)

    const pages = [
      ...pageBreakIndices.map((pageBreakIdx, idx) => idx),
      pageBreakIndices.length,
    ]

    let visibleSections = sections

    if (pageBreakIndices.length) {
      if (pageSelected === 0) {
        visibleSections = sections.slice(0, pageBreakIndices[0])
      } else if (pageSelected === pages.length - 1) {
        visibleSections = sections.slice(pageBreakIndices[pageSelected - 1])
      } /* (pageSelected !== pageBreakIndices.length - 1) */ else {
        visibleSections = sections.slice(
          pageBreakIndices[pageSelected - 1],
          pageBreakIndices[pageSelected],
        )
      }
    }

    const actualIndex = visibleSections[index].idx

    return resolve(
      dispatch({
        type: ActionType.CustomForm.CHANGE_SECTION,
        payload,
        index: actualIndex,
        id,
        visualIndex: index,
      }),
    )
  })

export const cancelEdit = id => (dispatch, getState) => {
  // const addOrEdit = getState().customForm.addOrEdit
  // const initialItemState = addOrEdit.initialItemState
  // const sectionBeingEditedID = addOrEdit.initialItemState

  dispatch({
    type: ActionType.CustomForm.CANCEL_EDIT,
    // payload: { initialItemState, sectionBeingEditedID },
  })
}

export const editSection = payload => (dispatch, getState) => {
  if (typeof payload === 'object') {
    const { index, item } = payload

    const { pageSelected, form, sectionsByID } = getState().customForm.addOrEdit
    const sections = form.sections.map((section, idx) => ({
      ...sectionsByID[section],
      idx,
    }))

    const pageBreakIndices = sections
      .map((section, idx) => ({ ...section, idx }))
      .filter(el => el?.type === 'pagebreak')
      .map(pagebreak => pagebreak.idx)

    const pages = [
      ...pageBreakIndices.map((pageBreakIdx, idx) => idx),
      pageBreakIndices.length,
    ]

    let visibleSections = sections

    if (pageBreakIndices.length) {
      if (pageSelected === 0) {
        visibleSections = sections.slice(0, pageBreakIndices[0])
      } else if (pageSelected === pages.length - 1) {
        visibleSections = sections.slice(pageBreakIndices[pageSelected - 1])
      } /* (pageSelected !== pageBreakIndices.length - 1) */ else {
        visibleSections = sections.slice(
          pageBreakIndices[pageSelected - 1],
          pageBreakIndices[pageSelected],
        )
      }
    }

    const actualIndex = visibleSections[index].idx

    return dispatch({
      type: ActionType.CustomForm.EDIT_SECTION,
      payload: { pageIndex: index, index: actualIndex, section: item },
    })
  }

  return dispatch({
    type: ActionType.CustomForm.EDIT_SECTION,
    payload: null,
  })
}

export const handleSectionValueChange = payload => dispatch =>
  dispatch({ type: ActionType.CustomForm.HANDLE_SECTION_VALUE_CHANGE, payload })

export const handleSectionFieldCheckboxChange = payload => dispatch =>
  dispatch({
    type: ActionType.CustomForm.HANDLE_SECTION_FIELD_CHECKBOX_CHANGE,
    payload,
  })

export const selectSection = (payload, item) => dispatch =>
  dispatch({ type: ActionType.CustomForm.SELECT_SECTION, payload, item })

export const deleteSection = payload => (dispatch, getState) => {
  const { pageSelected, form, sectionsByID } = getState().customForm.addOrEdit
  const sections = form.sections.map((section, idx) => ({
    ...sectionsByID[section],
    idx,
  }))

  const sectionsByIDWithIdx = sections.reduce((acc, el) => {
    acc[el.id] = el
    return acc
  }, {})

  const pageBreakIndices = sections
    .map((section, idx) => ({ ...section, idx }))
    .filter(el => el?.type === 'pagebreak')
    .map(pagebreak => pagebreak.idx)

  const pages = [
    ...pageBreakIndices.map((pageBreakIdx, idx) => idx),
    pageBreakIndices.length,
  ]

  let visibleSections = sections

  if (pageBreakIndices.length) {
    if (pageSelected === 0) {
      visibleSections = sections.slice(0, pageBreakIndices[0])
    } else if (pageSelected === pages.length - 1) {
      visibleSections = sections.slice(pageBreakIndices[pageSelected - 1])
    } /* (pageSelected !== pageBreakIndices.length - 1) */ else {
      visibleSections = sections.slice(
        pageBreakIndices[pageSelected - 1],
        pageBreakIndices[pageSelected],
      )
    }
  }

  if (typeof payload === 'number') {
    const actualIndex =
      pageSelected === 0
        ? visibleSections[payload].idx
        : visibleSections[payload].idx + 1

    dispatch({
      type: ActionType.CustomForm.DELETE_SECTION,
      payload: { index: actualIndex },
    })
  }

  if (typeof payload === 'string') {
    const actualIndex = sectionsByIDWithIdx[payload].idx

    dispatch({
      type: ActionType.CustomForm.DELETE_SECTION,
      payload: { index: actualIndex },
    })
  }
}

export const goToPage = payload => dispatch =>
  dispatch({ type: ActionType.CustomForm.GO_TO_PAGE, payload })

export const handleGroupChange = payload => dispatch =>
  dispatch({ type: ActionType.CustomForm.HANDLE_GROUP_CHANGE, payload })

export const handleGroupSuggestionClick = payload => dispatch =>
  dispatch({
    type: ActionType.CustomForm.HANDLE_GROUP_SUGGESTION_CLICK,
    payload,
  })

export const selectFormType = payload => dispatch =>
  dispatch({ type: ActionType.CustomForm.SELECT_FORM_TYPE, payload })

export const handleFormViewSelect = payload => dispatch =>
  dispatch({ type: ActionType.CustomForm.HANDLE_FORM_VIEW_SELECT, payload })

export const handleFormValueChange = (property, payload) => dispatch =>
  dispatch({
    type: ActionType.CustomForm.HANDLE_FORM_VALUE_CHANGE,
    property,
    payload,
  })

export const handleFormFieldChange = payload => dispatch =>
  dispatch({ type: ActionType.CustomForm.HANDLE_FORM_FIELD_CHANGE, payload })

export const handleFormDrag = payload => dispatch =>
  dispatch({ type: ActionType.CustomForm.HANDLE_FORM_DRAG, payload })

export const formFieldRequiredChange = payload => dispatch =>
  dispatch({ type: ActionType.CustomForm.FORM_FIELD_REQUIRED_CHANGE, payload })

export const receiveForm = payload => (dispatch, getState) => {
  const groupsLoadStatus = getState().loadStatus?.groups

  if (groupsLoadStatus === 'SUCCESS') {
    return Promise.resolve(
      dispatch({
        type: ActionType.CustomForm.RECEIVE_FORM,
        payload,
        groupsByID: getState().contacts.groupsByID,
        preferences: getState().data?.['account/preference']?.preferences,
      }),
    )
  }

  return dispatch(getAllGroups()).then(allGroupsPayload => {
    return Promise.resolve(
      dispatch({
        type: ActionType.CustomForm.RECEIVE_FORM,
        payload,
        groupsByID: allGroupsPayload?.reduce((acc, el) => {
          acc[el?.id] = el
          return acc
        }, {}),
        preferences: getState().data?.['account/preference']?.preferences,
      }),
    )
  })
}

export const toggleBottomNav = (event, payload) => dispatch =>
  dispatch({ type: ActionType.CustomForm.TOGGLE_BOTTOM_NAV, payload })

export const closeSnackbar = () => dispatch =>
  dispatch({ type: ActionType.CustomForm.CLOSE_SNACKBAR })

export const togglePreviewResponseView = payload => dispatch =>
  dispatch({
    type: ActionType.CustomForm.TOGGLE_PREVIEW_RESPONSE_VIEW,
    payload,
  })

export const toggleFormDataPanel = payload => dispatch =>
  dispatch({ type: ActionType.CustomForm.TOGGLE_FORM_DATA_PANEL, payload })

export const toggleBottomMenu = () => dispatch =>
  dispatch({ type: ActionType.CustomForm.TOGGLE_BOTTOM_MENU })

export const handleMultiOptionChange = payload => dispatch =>
  dispatch({ type: ActionType.CustomForm.HANDLE_MULTI_OPTION_CHANGE, payload })

export const prevAnalyticsPage = payload => dispatch =>
  dispatch({
    type: ActionType.CustomForm.PREV_ANALYTICS_PAGE,
    payload: { statsId: payload },
  })

export const nextAnalyticsPage = payload => dispatch =>
  dispatch({
    type: ActionType.CustomForm.NEXT_ANALYTICS_PAGE,
    payload: { statsId: payload },
  })

export const readNextAnalyticsPage = payload => dispatch =>
  new Promise((resolve, reject) => {
    const { statsId, params } = payload

    return dispatch(
      read(statsId, 'customFormStat', null, null, 'object', statsId, params),
    ).then(
      res => {
        resolve(
          dispatch({
            type: ActionType.CustomForm.NEXT_ANALYTICS_PAGE,
            payload: {
              statsId,
            },
          }),
        )
      },
      () => reject(),
    )
  })
